import Tiers from "./Tiers";

export default function Progression() {
  return (
    <Tiers />
  );
}
